import React from "react";
import cx from "classnames";
import {
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Image,
} from "react-bootstrap";
import dateformat from "dateformat";

import { FileService } from "src/utils/file.service";
import PlayButton from "src/legacy/components/PlayButton";
import withUseHooks from "src/legacy/components/withUseHooks";

import styles from "./styles.module.scss";
import Text from "src/components/text";

const AssetDefaultIcon = '/images/defaultIcons/default_asset.jpg';

class AssetShareView extends React.Component {
  constructor(props) {
    super(props);

    var hasAnalytics = false;
    if (FileService.hasAnalytics(this.props.asset.metadata)) {
      hasAnalytics = true;
    }
    this.handleAnalytics = this.handleAnalytics.bind(this);

    this.state = {
      pages: [],
      pageCount: 0,
      hasAnalytics: hasAnalytics,
      loadingAnalytics: false,
      fetchedAnalytics: false,
      activePage: null,
      chart: {
        width: 250,
        visible: false,
      },
    };
  }

  componentDidMount() {
    if (
      this.props.shouldFetchAnalytics &&
      this.state.hasAnalytics &&
      this.props.asset.analytics.fetch &&
      !this.state.fetchedAnalytics
    ) {
      this.props.fetchAssetAnalytics(this.props.sectionId, this.props.asset);

      this.setState({
        fetchedAnalytics: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.shouldFetchAnalytics &&
      this.state.hasAnalytics &&
      nextProps.asset.analytics &&
      nextProps.asset.analytics.fetch &&
      !this.state.fetchedAnalytics
    ) {
      this.props.fetchAssetAnalytics(nextProps.sectionId, nextProps.asset);

      this.setState({
        fetchedAnalytics: true,
      });
    }

    if (
      nextProps.asset.analytics &&
      nextProps.asset.analytics.loading != this.props.asset.analytics.loading
    ) {
      this.setState({
        loadingAnalytics: nextProps.asset.analytics.loading,
      });
    }
  }

  handleAnalytics(event) {
    event.preventDefault();
    if (this.props.shareId && this.props.asset.id && this.props.sectionId) {
      var analyticsUrl = `/opportunities/analytics?share=${this.props.shareId}&section=${this.props.sectionId}&asset=${this.props.asset.id}`
      this.props.navigate(analyticsUrl)
    }

    if (!this.props.sectionId && this.props.shareId && this.props.asset.id) {
      var analyticsUrl = `/opportunities/analytics?share=${this.props.shareId}&asset=${this.props.asset.id}`
      this.props.navigate(analyticsUrl)
    }
  }

  _handleAssetClick(assetURL) {
    const asset = {
      url: assetURL
    }
    window.parent.postMessage(asset, "*");
  }

  render() {
    var assetViewEvent = null;
    var downloadViewEvent = null;

    const timeSpent = this.props.asset.totalTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    if (this.props.events) {
      this.props.events.forEach((event) => {
        switch (event.type) {
          case "asset_viewed":
            assetViewEvent = event;
            break;
          case "asset_download":
            downloadViewEvent = event;
            break;

          default:
            break;
        }
      });
    }

    return (
      <Row className={cx(styles.asset, this.props.className)}>
        <Col className={styles.noPadding}>
          <div className={styles.assetContainer}>
            <div className={styles.analyticsContainer}>
              <div className={styles.iconContainer}>
                {this.props.asset.metadata && (
                  <PlayButton
                    asset={this.props.asset}
                    className={styles.playButton}
                    size={35}
                  />
                )}
                <Image onClick={() => { this._handleAssetClick(this.props.asset.id) }}
                  className={styles.icon} src={this.renderAssetIcon()} />
              </div>

              <div>
                <a
                  onClick={() => {
                    this._handleAssetClick(this.props.asset.id)
                  }}
                  className={styles.assetLink}
                >
                  <div className={styles.name}>
                    <Text text={this.props.asset.name} lines={1} />
                  </div>
                </a>
                <Col
                  sm={12}
                  className={cx(styles.assetMetrics, styles.noPadding)}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip">
                        {assetViewEvent
                          ? `Last viewed on ${dateformat(
                            assetViewEvent.createdDate,
                            "dd mmm yyyy"
                          )}`
                          : "Not yet viewed"}
                      </Tooltip>
                    }
                  >
                    <div className={styles.metrics}>
                      <span className="paperflite-eye"></span>
                      <label>{assetViewEvent ? assetViewEvent.count : 0}</label>
                    </div>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip">
                        {downloadViewEvent
                          ? `Last downloaded on ${dateformat(
                            downloadViewEvent.createdDate,
                            "dd mmm yyyy"
                          )}`
                          : "Not yet downloaded"}
                      </Tooltip>
                    }
                  >
                    <div className={styles.metrics}>
                      <span className="paperflite-download"></span>
                      <label>
                        {downloadViewEvent ? downloadViewEvent.count : 0}
                      </label>
                    </div>
                  </OverlayTrigger>

                  <div className={styles.metrics}>
                    <span className="paperflite-history"></span>
                    <label>{timeSpentValue}</label>
                  </div>
                </Col>
              </div>
            </div>

            <div>
              <Col md={7}>
                <button onClick={this.handleAnalytics.bind(this)} className={styles.analyticsButton} >
                  <i className="paperflite-analytics"></i> Analytics
                </button>
              </Col>
            </div>
          </div>
        </Col>
      </Row>
    );
  }

  renderAssetIcon() {
    var icon = AssetDefaultIcon;
    if (this.props.asset.icon) {
      icon = this.props.asset.icon.thumbnail;
    }

    return icon;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }

    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

export default withUseHooks(AssetShareView);